import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, MessageResponseDataSchema } from "schema"
import { z } from "zod"

type Params = {
  messageId: string
  rating: "POSITIVE" | "NEGATIVE"
}

type Props = {
  onError?: (error: Error) => void
  onSuccess?: () => void
}

type Response = DataResponse<z.infer<typeof MessageResponseDataSchema>>

export function useRateMessageMutation(props: Props) {
  return useMutation<Response, Error, Params>({
    mutationFn: async (params) => {
      const response = await axios.post<Response>(`/messages/${params.messageId}/rate`, {
        rating: params.rating,
      })

      return response.data
    },
    onSuccess: () => props.onSuccess?.(),
    onError: (err) => props.onError?.(err),
  })
}
